namespace MathUtils {
  /**
   * Rounds a number to whatever number of places you pass in
   *
   * @param value number to round
   * @param places number of places to round to
   * @returns
   */
  export function round(value: number, place: number): number {
    if (place === 0) {
      return Math.round(value);
    }
    if (place < 1) {
      const expo = Math.log10(place);
      const adjustedNum = 10 ** Math.abs(expo);
      return Math.round(value * adjustedNum) / adjustedNum;
    }
    return Math.round(value / place) * place;
  }

  /**
   * Calculates in percent, the change between 2 numbers.
   * e.g from 1000 to 500 = 50%
   *
   * @param oldVal The initial value
   * @param newVal The value that changed
   */
  export function percentChange(oldVal: number, newVal: number): number {
    return ((newVal - oldVal) / oldVal) * 100;
  }

  /**
   * Calculates the percentage change from the initialValue to the currentValue
   * @param {number} currentValue The value currently being evaluated
   * @param {number} initialValue The initial value being compared against
   * @returns {number} The percentage change from the initialValue to the currentValue
   */
  export function getPercent(currentValue: number, initialValue: number) {
    return (currentValue / initialValue) * 100;
  }

  /**
   * Returns true if the currentValue is greater than the initialValue
   * @param currentValue The value currently being evaluated
   * @param initialValue The initial value being compared against
   * @returns boolean indicating whether the currentValue is a profit
   */
  export function isProfit(currentValue: number, initialValue: number) {
    return currentValue > initialValue;
  }
}

export default MathUtils;
